/* eslint-disable */

// This file does not go through babel. So we are stuck with es5 here.

// Fonts
export const fontFamily =
  '"Open Sans"; -apple-system; BlinkMacSystemFont; "Segoe UI"; Roboto; Oxygen; Ubuntu; Cantarell; "Helvetica Neue"; sans-serif';
export const light = 300;
export const roman = 400;
export const semiBold = 600;
export const bold = 700;
export const sizeLarge = '20px';
export const sizeBody1 = '16px';
export const sizeBody2 = '14px';
export const sizeCaption = '12px';
export const sizeH1 = '36px';
export const sizeH2 = '32px';
export const sizeH3 = '24px';
export const sizeH4 = '18px';
export const sizeH5 = '16px';
export const sizeH6 = '14px';
export const lineHeightSmallest = '14px';
export const lineHeightSmall = '16px';
export const lineHeightNormal = '18px';
export const lineHeightBig = '24px';
export const lineHeightLarge = '32px';
export const lineHeightLargest = '40px';

// Colors
export const red = '#BC1C1C';
export const yellow = 'rgb(244, 195, 9)';
export const green = '#4ED966';
export const blue = 'rgb(23, 174, 201)';
export const white = '#FFFFFF';
export const grey05 = '#A1A4B1';
export const whisper = '#F4F4F4';
export const nearWhite = '#FCFCFC';
export const black = '#000000';
export const black5 = '#F2F2F2';
export const black10 = '#E6E7E8'; // popular
export const black20 = '#D1D3D4'; // popular
export const black30 = '#BCBEC0';
export const black40 = '#A7A9AC'; // popular
export const black50 = '#939598';
export const black60 = '#808285';
export const black70 = '#6D6E71';
export const black80 = '#58595B'; // popular
export const black90 = '#414042'; // popular
export const gold = 'rgb(166, 122, 46)';
export const gold5 = '#FAF7F4';
export const gold70 = '#CDBA97';
export const goldLight = '#EDE4D5';
export const influenceMYellow = '#E6B029';
export const facebookBlue = '#3b5998';
export const purple = '#9B51E0';
export const purpleLight = '#EBDCF9';
export const purpleBackground = '#FFF6FF';
export const transparentPurple = 'rgba(155, 81, 224, 0.2)';
export const inputPlaceholder = '#6A6A6A';
export const transparentBlack = 'rgba(0, 0, 0, 0.2)';

// Client Web App current colours for use with InfluenscoreChart etc.
export const coloursClientWebApp = {
  black: '#000000',
  eerieBlack: '#101010',
  onyx: '#121212',
  codGray: '#0b0b0b',
  almostBlack: '#242424',
  white: '#ffffff',
  offWhite: '#f0f0f0',
  silver: '#BDBDBD',
  magnesium: '#B6B6B6',
  sunglow: '#FFCF4C',
  vividSkyBlue: '#00E0FF',
  malachite: '#00FF51',
  ruddy: '#FF001E',
};

// Variables
export const bigScreen = '1540px';
export const gridRowSpacing = '16px';
export const gridGutter = '12px';
export const mainContentWidth = '1130px';
export const smallScreen = '1440px';
export const transitionTimeBase = '0.2s';
export const boxShadowBase = '0 1px 5px rgba(0, 0, 0, 0.1)';
export const topNavHeight = '56px';
export const secondaryNavHeight = 'auto';
